import React, {Component} from 'react';
import moment from 'moment';
import ExcelDownBtn from '@app/components/ExcelDownBtn.js';

class CsDataExportExcel extends Component {
	constructor(props) {
		super(props);
		
	}

	render() {
		const list = this.props.list;
		
		const columns = [
			"날짜", "번호", "상품", "단말기", "저장공간", "버전", "메뉴", "기관", "문의자", "번호", "요청자", "처리자", "문의 사항", "처리 내역", "현황", "이슈"
		];

		const dataList = [];
		let dateCriteria = '';
		for(var i in list) {
			const row = list[i];
			let ii = 1;

			if(dateCriteria != moment(row.request_date).format('YYYY-MM-DD') && ii >= 1 ) {
				dateCriteria = moment(row.request_date).format('YYYY-MM-DD');
				ii = 1;
			} else {
				ii += 1;
			}

			const data = [];
			data.push(row.request_date);
			data.push(ii);
			data.push(row.product_name);
			data.push(row.device);
			data.push(row.storage);
			data.push(row.version);
			data.push(row.type_name);
			data.push(row.organization);
			data.push(row.requestor);
			data.push(row.phone);
			data.push("");
			data.push(row.user_name);
			data.push(row.question);
			data.push(row.answer);
			data.push(row.is_complete === 'N' ? '확인 중' : '처리 완료');
			data.push(row.is_issue === 'N' ? '' : '이슈');

			dataList.push(data);
		}

		return (
			<ExcelDownBtn 
				fileName="CS data 백업"
				dataSet={[
					{ 
						columns,
						data: dataList
					}
				]}
				btn={this.props.btn}
				name="CS 백업"
			/>
		)
	}
}

export default CsDataExportExcel;